export default function Accordion(theme: any) {
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    margin: 0,
                    '&.Mui-expanded': {
                        margin: theme.spacing(0, 0, 2, 0),
                    },
                    '& .MuiAccordionSummary-root': {
                        alignItems: 'center',
                        '&.Mui-expanded': {
                            minHeight: 'initial'
                        },
                    }
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    '& .MuiAccordionSummary-content': {
                        alignItems: 'center',
                    },
                    '&.Mui-expanded': {
                        margin: 0,
                        '& .MuiAccordionSummary-content': {
                            margin: theme.spacing(1.5, 0),
                        }
                    },
                },
            },
        },
    };
}
